<div class="card">
  <div class="card-body">
    <h5 class="mb-3"><b><i class="fas fa-users"></i> User Edit  </b></h5>
    <div class="col-12">
      <div class="col-7  align-items-center mx-auto">
        <form [formGroup]="userForm">

          <input formControlName="username" class="form-control mb-3" placeholder="Username" type="text">
          <input formControlName="email" class="form-control mb-3" placeholder="Email" type="text">
          <input formControlName="mobileNo" class="form-control mb-3" placeholder="Mobile" type="text">


          <div class="text-center mb-3">
            <button [ladda]="isLoading" data-style="slide-left"
                    data-spinner-size="30" (click)="change()" [disabled]="!userForm.valid"
                    class="btn btn-block btn-success my-2" type="button">Change
            </button>
          </div>
          <div class="row mb-3">

            <div class="col-12">
              <div class="or-image"></div>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
